export interface GridColumnRenameMap { [oldName: string]: string }

// Renames per NGXS state source (the segment before ".grids." in a grid config's storage key,
// e.g. 'Builds'). Add/extend an entry whenever a grid's GridColumn.name values change, so saved
// visibleColumns/order.by values migrate forward instead of silently vanishing.
const GRID_COLUMN_RENAMES_BY_SOURCE: { [source: string]: GridColumnRenameMap } = {
  Builds: {
    'FirstNotification.ProcessNotification.StartTime': 'Process.LastProcessAttempt.CreatedOn',
    'LastNotification.ProcessNotification.StartTime': 'Process.LastProcessAttempt.EndedOn',
    'LastNotification.ProcessState': 'Process.LastProcessAttempt.Status',
    WarningCount: 'Process.LastProcessAttempt.WarningCount',
    ErrorCount: 'Process.LastProcessAttempt.ErrorCount'
  },
  Publications: {
    'FirstNotification.ProcessNotification.StartTime': 'Process.LastProcessAttempt.CreatedOn',
    'LastNotification.ProcessNotification.StartTime': 'Process.LastProcessAttempt.EndedOn',
    'LastNotification.ProcessState': 'Process.LastProcessAttempt.Status',
    WarningCount: 'Process.LastProcessAttempt.WarningCount',
    ErrorCount: 'Process.LastProcessAttempt.ErrorCount'
  }
};

const GRID_CONFIG_KEY_PATTERN = /^([^.]+)\.grids\.[^.]+\.config$/;

/**
 * Renames persisted grid `visibleColumns` entries and sort `order.by` values from their old or
 * transient forms to their current property-path names, per the source's entry (if any) in
 * {@link GRID_COLUMN_RENAMES_BY_SOURCE}, so a user's saved grid customizations aren't silently
 * dropped/reset after a column rename.
 */
export function renameGridColumnNames(state: unknown, key: string): unknown {
  const match = GRID_CONFIG_KEY_PATTERN.exec(key);
  const renames = match ? GRID_COLUMN_RENAMES_BY_SOURCE[match[1]] : null;

  if (!renames) {
    return state;
  }

  const configState = state as { visibleColumns?: string[]; order?: { by?: string } };

  if (Array.isArray(configState?.visibleColumns)) {
    configState.visibleColumns = configState.visibleColumns.map((name: string) => renames[name] ?? name);
  }

  if (configState?.order?.by && renames[configState.order.by]) {
    configState.order.by = renames[configState.order.by];
  }

  return state;
}
